module.exports = __webpack_public_path__ + "img/government.3a3fa6a9.png";